import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 15v-8h8","key":"svg-0"}],["path",{"d":"M11 19v-8h8","key":"svg-1"}]]

const IconChevronsUpLeft = createReactComponent('outline', 'chevrons-up-left', 'ChevronsUpLeft', __iconNode);

export default IconChevronsUpLeft;